import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCommentNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M5 8h14v2H5zM5 12v2h11v-2z" />
        <path d="M0 6a3 3 0 013-3h18a3 3 0 013 3v10a3 3 0 01-3 3h-9.586l-4.5 4.5A1.707 1.707 0 014 22.293V19H3a3 3 0 01-3-3zm3-1a1 1 0 00-1 1v10a1 1 0 001 1h3v4.586l4-4A2 2 0 0111.414 17H21a1 1 0 001-1V6a1 1 0 00-1-1z" />
      </g>
    </svg>
  )
);
SvgActionsCommentNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCommentNormalSmall;
